import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { store } from '../../../index';

function CheatVoteComp() {
	const [show, setShow] = useState(true);
	const showCheatVote = useSelector((state) => state.clock.showCheatVote);

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	const dispatch = useDispatch();

	const vote = (value) => {
		store.dispatch({ type: 'CHEAT_VOTE', value: value });
		handleClose();
	};
	return (
		<div>
			<Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
				<Modal.Header closeButton>
					<Modal.Title>Vote!</Modal.Title>
				</Modal.Header>
				<Modal.Body>Do you think your opponent cheated ?</Modal.Body>
				<Modal.Footer style={{ margin: 'auto' }}>
					<Button variant="secondary" onClick={() => vote(false)}>
						No
					</Button>
					<Button variant="primary" onClick={() => vote(true)}>
						Yes
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
}

export default CheatVoteComp;
